var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    breadcrumbs: true,
    'breadcrumbs-dark': _vm.dark,
    'breadcrumbs-light': !_vm.dark,
  },style:({ '--primary-btn': _vm.dark ? '#0084ff' : '#ffffff' })},[_c('ul',{class:{ 'game-ul': _vm.templateName && _vm.gameBlockTitle != '' }},_vm._l((_vm.breadcrumbData),function(data,index){return _c('li',{key:index},[(_vm.$root.enable_piwik_reload)?[(index === _vm.breadcrumbData.length - 1)?[(data.type === 'custom')?_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title))]):_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title)+"\n          ")])]:[(data.type === 'custom')?_c('a',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('a',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"href":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title)+"\n          ")])]]:[(index === _vm.breadcrumbData.length - 1)?[(data.type === 'custom')?_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title))]):_c('span',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            }},[_vm._v(_vm._s(data.title)+"\n          ")])]:[(data.type === 'custom')?_c('a',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"href":data.url}},[_vm._v(_vm._s(data.title))]):_c('router-link',{class:{
              'router-link-exact-active cursor-link':
                index === _vm.breadcrumbData.length - 1,
            },attrs:{"title":data.title,"to":_vm.getRouteLink(data.slug, data.type, data.base_slug)}},[_vm._v(_vm._s(data.title)+"\n          ")])]]],2)}),0),_vm._v(" "),(_vm.templateName && _vm.gameBlockTitle != '')?_c('span',{class:{
      'span-h1 custom-font-1 cust-h1 game-span': true,
      'text-light': !_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg),
    }},[_vm._v(_vm._s(_vm.gameBlockTitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abfab7e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Breadcrumb.vue
// module id = 601
// module chunks = 1